import { useTranslation } from "react-i18next";

import { useCollectionData } from "astrid-firestore/src/hooks";

import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";
import PageView from "../../../ui/views/PageView/PageView";

import OrdersAccordion from "../../components/OrdersAccordion/OrdersAccordion";
import useOrdersQuery from "../../hooks/useOrdersQuery";

export default function PublisherSalesOrdersView({ publisher }) {
	const { t } = useTranslation();

	const [orders = [], loading, error] = useCollectionData(
		useOrdersQuery({ expense: false, secondPartyId: publisher.id }).orderBy("created", "desc").limit(100),
	);

	return (
		<PageView header={t("salesOrders", "Sales orders")} maxWidth={1400}>
			<LoadingContext data={orders} loading={loading} error={error}>
				<OrdersAccordion orders={orders} readOnly />
			</LoadingContext>
		</PageView>
	);
}
